import { type IWizardStep } from "interfaces";
import { type FC, useEffect } from "react";
import { RolePermissions, type UsersGroupsContext } from "../../../../enums";
import PeopleWrapper from "../../PeopleAssignments/Overview/PeopleWrapper/PeopleWrapper";
import GroupsOverview from "./GroupsOverview";
import UsersOverview from "./UsersOverview";

interface EditEmbeddedVideoPeopleProps extends IWizardStep {
  embeddedVideoId: number;
  usersGroupsContext: UsersGroupsContext;
  onContextChanged: (value: UsersGroupsContext) => void;
}

export const EditPdfPeople: FC<EditEmbeddedVideoPeopleProps> = ({
  embeddedVideoId,
  usersGroupsContext,
  acceptHandlers,
  onContextChanged,
}) => {
  useEffect(() => {
    acceptHandlers?.({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <PeopleWrapper
        permission={RolePermissions.AssetsManage}
        usersGroupsContext={usersGroupsContext}
        onContextChanged={onContextChanged}
        renderGroupsOverview={(customHeaderContent: React.ReactElement) => (
          <GroupsOverview embeddedVideoId={embeddedVideoId} customHeaderContent={customHeaderContent} />
        )}
        renderUsersOverview={(customHeaderContent: React.ReactElement) => (
          <UsersOverview embeddedVideoId={embeddedVideoId} customHeaderContent={customHeaderContent} />
        )}
      />
    </>
  );
};

export default EditPdfPeople;
